/** The Customers list's client-side matching over the `GET /customers` snapshot. */

type Field = string | number | string[] | null | undefined;

export interface CustomerFilterRow {
  companyid?: Field;
  company_name?: Field;
  platform?: Field;
  mlsids?: Field;
  dataserver?: Field;
  domain?: Field;
  website?: Field;
}

/** A customer's feed ids as a list, whether the API sent one id or many. */
export const feedsOf = (customer?: Pick<CustomerFilterRow, 'mlsids'> | null): string[] => {
  const feeds = customer?.mlsids;
  return Array.isArray(feeds) ? feeds : feeds ? [String(feeds)] : [];
};

/** Every chosen filter must hold; an empty choice means no filter on that field. */
export function matchesCustomerFilters(
  customer: CustomerFilterRow,
  { platform, feed, dataserver }: { platform: string; feed: string; dataserver: string },
): boolean {
  return (
    (!platform || customer.platform === platform) &&
    (!feed || feedsOf(customer).includes(feed)) &&
    (!dataserver || customer.dataserver === dataserver)
  );
}

/** True when `needle` (any case) is in the customer's id, name, feeds, sites, office website, data server or platform. */
export function matchesCustomerSearch(customer: CustomerFilterRow, needle: string): boolean {
  const lowered = needle.toLowerCase();
  return [
    customer.companyid,
    customer.company_name,
    customer.mlsids,
    customer.domain,
    customer.website,
    customer.dataserver,
    customer.platform,
  ].some((value) => value?.toString().toLowerCase().includes(lowered));
}
